import React from 'react';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import notFoundImage from 'assets/img/404.svg';

const NotFound = () => {
  const { t } = useTranslation('common');
  return (
    <Container fluid className={'text-center mt-5 pt-5'}>
      <h1>{t('notFound.header')}</h1>
      <p>{t('notFound.text')}</p>
      <br />
      <img alt="Page not found logo" src={notFoundImage} />
    </Container>
  );
};

export default NotFound;
